import { Button, FeaturedIcon } from '@/lib';
import { LockIcon } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AIAnalysisLocked = ({
  handleEnableConsent,
  isEnablingConsent,
  isWorkspaceDetailsFetching,
}: {
  handleEnableConsent: () => Promise<void>;
  isEnablingConsent: boolean;
  isWorkspaceDetailsFetching: boolean;
}) => {
  const { t } = useTranslation('marketIntelligence');

  return (
    <>
      <h3 className='text-3xl font-bold tracking-tight text-primary-900'>
        <span className='text-primary-alt'>{t('report.suggestedAudiences.titlePrefix')}</span> {t('report.suggestedAudiences.titleSuffix')}
      </h3>

      <div className='mt-5 flex flex-col items-center gap-2.5 rounded-xl border border-dashed border-brand-200 bg-white px-6 py-9 text-center'>
        <FeaturedIcon color='brand' size='md' type='light'>
          <LockIcon className='size-5 text-primary-alt' />
        </FeaturedIcon>
        <p className='text-lg font-semibold text-primary-900'>{t('report.suggestedAudiences.consentOff.title')}</p>
        <p className='max-w-xl text-sm leading-6 text-grey-600'>{t('report.suggestedAudiences.consentOff.description')}</p>
        <Button intent='primary' size='md' className='mt-2' onClick={handleEnableConsent} isLoading={isEnablingConsent} disabled={isWorkspaceDetailsFetching}>
          {t('report.suggestedAudiences.consentOff.cta')}
        </Button>
        <p className='text-xs text-primary-500'>{t('report.suggestedAudiences.consentOff.hint')}</p>
      </div>
    </>
  );
};
